// @ts-nocheck
import { ProductPrimaryImageStyles } from "@insite/content-library/Components/ProductPrimaryImage";
import { ModalPresentationProps } from "@insite/mobius/Modal/Modal";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CarouselButtonPresentationProps } from "@store/Library/Components/Toolkit/Carousel/CarouselButton";
import Play from "@store/Library/Components/Toolkit/Icons/Play";
import { VideoPresentationProps } from "@store/Library/Components/Toolkit/Video/Video";
import { imageStyles } from "@store/Themes/common/mixins/image";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusStyles } from "@toolkit/Themes/common/mixins/common";
import { css } from "styled-components";

/* Store Custom Code - Start */
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
/* Store Custom Code - End */

export const primaryImageModalZoomMaxsize = 95;
export const productDetailsPrimaryImageMaxWidth = pxToRem(400);

const videoStyles = () => {
    return css`
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    `;
};

export interface ProductDetailsProps {
    primaryImage?: ProductPrimaryImageStyles;
    primaryImagePlayButton?: CarouselButtonPresentationProps;
    fullPrimaryImageModal?: ModalPresentationProps;
    fullPrimaryImage?: ProductPrimaryImageStyles;
    videoWrapper?: InjectableCss;
    video?: VideoPresentationProps;
}

export const productDetailsProps: ProductDetailsProps = {
    primaryImage: {
        centeringWrapper: {
            css: css`
                ${x => imageStyles(x.theme.design.product.image.medium.ratio)}
                max-height: ${pxToRem(400)};
                margin: 0 auto;

                /* Store Custom Code - Start */
                width: 95%;
                box-shadow: ${x => x.theme.shadows[3]};

                ${breakpoint("sm")} {
                    width: ${productDetailsPrimaryImageMaxWidth};
                }
                /* Store Custom Code - End */
            `,
        },
        img: {
            css: css`
                ${focusStyles(true)}
                cursor: zoom-in;
            `,
        },
    },
    primaryImagePlayButton: {
        iconSize: "1.75em",
        iconSrc: Play,
        iconMargin: "0 -0.3em 0 0",
        extendedStyles: {
            wrapper: {
                css: css`
                    position: absolute;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                `,
            },
            button: {
                css: css`
                    width: 2.5em;
                    height: 2.5em;
                `,
            },
        },
    },
    fullPrimaryImageModal: {
        closeButtonIconProps: {
            css: css`
                ${x => x.theme.modal.defaultProps?.closeButtonIconProps?.css}
                top: 0 !important;
            `,
        },
        closeButtonProps: {
            css: css`
                ${x => x.theme.modal.defaultProps?.closeButtonProps?.css}
                display: flex;
                padding: ${pxToRem(7)} !important;
                margin: 0 !important;
            `,
        },
        cssOverrides: {
            modalContainer: css`
                width: auto;
            `,
            modalBody: css`
                height: auto !important;
                max-height: ${primaryImageModalZoomMaxsize}vh !important;
                margin: 0 !important;
            `,
            modalTitle: css`
                position: absolute;
                top: 0;
                right: 0;
                z-index: 1;
                padding: 0;
                border-bottom: none;
                background-color: ${getColor("common.background")};
                box-shadow: ${x => x.theme.shadows["1"] /* Store Custom Code */};
            `,
            modalContent: css`
                text-align: center;
                padding: 0;
            `,
        },
    },
    fullPrimaryImage: {
        centeringWrapper: {
            css: css`
                margin: 0;
            `,
        },
        img: {
            css: css`
                cursor: default;
                display: block;
                width: auto;
                height: auto;
                margin: 0 auto;
                max-height: ${primaryImageModalZoomMaxsize}vh;
                max-width: ${primaryImageModalZoomMaxsize}vw;
            `,
        },
    },
    videoWrapper: {
        css: css`
            position: relative;
            height: 0 !important;
            overflow: hidden;
            padding-bottom: 56.25%;
        `,
    },
    video: {
        extendedStyles: {
            video: {
                css: css`
                    ${videoStyles}
                `,
            },
            iframe: {
                css: css`
                    ${videoStyles}
                `,
            },
        },
    },
};
